import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";
import { CheckCircle, Error } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  alertContainer: {
    position: "fixed",
    bottom: (props) => props.height || 0,
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 999,
    padding: "16px 24px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    minWidth: "300px",
    maxWidth: "800px",
    boxShadow: "0 -4px 20px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    backdropFilter: "blur(8px)",
  },
  success: {
    backgroundColor: "rgba(22, 163, 74, 0.95)",
    color: "#ffffff",
  },
  error: {
    backgroundColor: "rgba(220, 38, 38, 0.95)",
    color: "#ffffff",
  },
  hidden: {
    transform: (props) =>
      `translate(-50%, calc(100% + ${props.height || 0}px))`,
  },
  icon: {
    fontSize: 24,
  },
  message: {
    fontSize: "0.95rem",
    fontWeight: 500,
    flex: 1,
  },
}));

const CustomAlert = ({
  severity,
  message,
  duration = 3000,
  onClose,
  height = 0,
}) => {
  const classes = useStyles({ height });
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (message) {
      setIsVisible(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onClose) {
          setTimeout(onClose, 400);
        }
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [message, duration, onClose]);

  if (!message) return null;

  const containerClassName = [
    classes.alertContainer,
    severity === "success" ? classes.success : classes.error,
    !isVisible ? classes.hidden : "",
  ].join(" ");

  return (
    <Box className={containerClassName}>
      {severity === "success" ? (
        <CheckCircle className={classes.icon} />
      ) : (
        <Error className={classes.icon} />
      )}
      <Typography className={classes.message}>{message}</Typography>
    </Box>
  );
};

export default CustomAlert;
